import { FC } from "react";
import { Trans } from "react-i18next";

import useSubscriptionPrices from "hooks/useSubscriptionPrices";

import { Text } from "uikit";

import { PlanSection, PlanSectionInner, Price, PricingBlock, PricingContainer } from "./styles";

interface IProps {
  pricingFooter?: React.ReactNode;
  footerMessage?: string;
  className?: string;
}

const SubscriptionPricingSection: FC<IProps> = ({ pricingFooter, footerMessage, className }) => {
  const { comprehensiblePrices } = useSubscriptionPrices({});
  const translationPrefixSubscriptionComponents = `timesheets_pages.admin.shared.subscription.components`;
  const translationPrefix = `${translationPrefixSubscriptionComponents}.pricing_section`;

  return (
    <PlanSection className={className}>
      <PlanSectionInner>
        <PricingContainer>
          <PricingBlock>
            <Text $fs="t12" $fw="semiBold">
              <Trans i18nKey={`${translationPrefix}.base_plan_label`} />
            </Text>
            <Price>
              <Text $fs="h24" $fw="bold">
                {comprehensiblePrices.basePrice}
              </Text>
              <Text $fs="t12" $variant="secondary">
                <Trans i18nKey={`${translationPrefix}.base_plan_price`} />
              </Text>
            </Price>
          </PricingBlock>

          <PricingBlock>
            <Text $fs="t12" $fw="semiBold">
              <Trans i18nKey={`${translationPrefix}.additional_workers_label`} />
            </Text>
            <Price>
              <Text $fs="h24" $fw="bold">
                {comprehensiblePrices.additionalPrice}
              </Text>
              <Text $fs="t12" $variant="secondary">
                <Trans i18nKey={`${translationPrefix}.additional_workers_price`} />
              </Text>
            </Price>
          </PricingBlock>
        </PricingContainer>

        {pricingFooter}
      </PlanSectionInner>

      {footerMessage && (
        <Text $fs="t12" $color="gray.700" $align="center" $p="10px 12px">
          <Trans i18nKey={footerMessage} />
        </Text>
      )}
    </PlanSection>
  );
};

export default SubscriptionPricingSection;
